import { useEffect, useState, useRef } from 'react'
import Header from './components/layout/Header'
import SplashScreen from './components/sections/SplashScreen'
import HeroSection from './components/sections/HeroSection'
import PlansSection from './components/sections/PlansSection'

function App() {
  const [showSplash, setShowSplash] = useState(true)
  const heroLogoRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false)
    }, 2200) // Tiempo total de la animación completa

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="min-h-screen">
      {showSplash && <SplashScreen heroLogoRef={heroLogoRef} />}
      <Header />
      <main>
        <HeroSection heroLogoRef={heroLogoRef} />
        <PlansSection />
      </main>
    </div>
  )
}

export default App
